import {BaseIdCodeModel, BaseIdModel} from "common-shared";
import {Exclude, Type} from "class-transformer";
import {MasterOperationModel} from "web-shared";
import {ProcessSelectorModel} from "web-shared";
import {SpecLineModel} from "web-shared";
import {GraphModel} from "../graph/models/graph.model";

export class ConfigurationModel extends BaseIdCodeModel {
  constructor(init?: Partial<ConfigurationModel>) {
    super();
    Object.assign(this, init);
  }
  @Type(() => ExplodeOptions)
  Options: ExplodeOptions;
  Customer: string;
  @Type(() => Date)
  DueDate: Date;
  ItemGroupId: string;
  ItemId: string;
  @Type(() => MasterOperationModel)
  MasterOperations: MasterOperationModel[];
  ProcessSelectors: ProcessSelectorModel[] = [];
  ModifiedBy: string;
  ModifiedDate: string;
  OrderClassClv: string;
  Quantity: number;
  OrderTypeClv: string;
  Priority: number;
  @Type(() => SpecLineModel)
  Specs: SpecLineModel[] = [];
  ConfigurationBatchId: string;
  StatusClv: string;
  Weight: number;
  Price: number;
  EAN: string;
  Name: string;
  @Exclude()
  ItemCode: string;
  @Exclude()
  Status: string;
  Log: string;
  @Type(() => MasterPegModel)
  MasterPegsByRightConfigurationId: MasterPegModel[];

  @Type(() => MasterPegModel)
  MasterPegsByLeftConfigurationId: MasterPegModel[];

  @Type(() => MasterFinanceIntegrationEntryModel)
  @Exclude({ toPlainOnly: true })
  MasterFinanceIntegrationEntries: MasterFinanceIntegrationEntryModel[];

  @Type(() => GraphModel)
  Graph: GraphModel;
  AssignedTo: string;
  Contact: string;

  ensurePeg(masterInputInstructionId: string) {
    let masterPegModel = this.MasterPegsByRightConfigurationId.find(value => value.MasterInputInstructionId == masterInputInstructionId);
    if (masterPegModel == null) {
      masterPegModel = new MasterPegModel({MasterInputInstructionId: masterInputInstructionId});
      this.MasterPegsByRightConfigurationId = [...this.MasterPegsByRightConfigurationId, masterPegModel]
    }
    return masterPegModel;
  }

  isValid(): boolean {
    return this.Specs.every(spec => spec.isValid());
  }

  isImeLoaded(): boolean {
    return this.MasterOperations?.length > 0;
  }
}

export class ExplodeOptions {
  OnlyValid: boolean;
  UseRowVersion: boolean;
}

export class MasterPegModel extends BaseIdModel {
  constructor(init?: Partial<MasterPegModel>) {
    super();
    Object.assign(this, init);
  }

  @Type(() => ConfigurationModel)
  LeftConfiguration: ConfigurationModel;
  MasterInputInstructionId: string;
  ConfigurationId: string;
}

export class MasterFinanceIntegrationEntryModel extends BaseIdCodeModel {
  Amount: number;
  CostPriceComponentId: string;
  CreatedBy: string;
  CreatedDate: Date;
  FinanceTransactionTypeClv: string;
  ItemId: string;
  ItemGroupId: string;
  MasterInputInstructionId: string;
  MasterOutputInstructionId: string;
  MasterUseInstructionId: string;
  Price: number;
  ProcessId: string;
  ProcessNumber: string;
  Quantity: number;
  Resources: string[] = [];
  SalesOrderId: string;
  UnitId: string;
  Main: boolean;
  RequiredResourceQuantity?: number;
  ProcessSelectorId: string;

  get QuantityForResource() {
    return this.Quantity / (this.RequiredResourceQuantity || 1);
  }
}
